import React, { useState } from 'react';
import classNames from 'classnames';
import useResizeObserver from 'hooks/use_resize_observer';

type LoadingShimmerProps = {
  className?: string;
}

export default function LoadingShimmer({ className, ...props }: LoadingShimmerProps) {
  const [width, setWidth] = useState<number>();
  const [height, setHeight] = useState<number>();

  const ref = useResizeObserver(({ height, width }) => {
    setWidth(width);
    setHeight(height);
  });

  return (
    <div className={classNames('loading-shimmer w-100', className)} ref={ref} {...props}>
      <div className="placeholder rounded h-100 w-100" style={{ height: height || 0, width: width || 0 }} />
    </div>
  );
}
